import { render, staticRenderFns } from "./TextAreaField.vue?vue&type=template&id=1c0ccf42&scoped=true&"
import script from "./TextAreaField.vue?vue&type=script&lang=js&"
export * from "./TextAreaField.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaField.vue?vue&type=style&index=0&id=1c0ccf42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ccf42",
  null
  
)

export default component.exports